(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["micotix-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class EcomHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track  = this.querySelector('.ecom-hero-slider__track');
      this.dots   = this.querySelectorAll('.ecom-hero-slider__dot');
      this.slides = this.querySelectorAll('.ecom-hero-slider__slide');
      this.current = 0;
      this.total   = this.slides.length;
      this.autoplayTimer = null;
      this.touchStartX = 0;

      if (this.total <= 1) return;

      this.querySelector('.ecom-hero-slider__arrow--prev')?.addEventListener('click', () => this.prev());
      this.querySelector('.ecom-hero-slider__arrow--next')?.addEventListener('click', () => this.next());

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

      this.addEventListener('touchstart', (e) => { this.touchStartX = e.changedTouches[0].screenX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const diff = this.touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
      });

      const delay = parseInt(this.dataset.autoplay, 10);
      if (delay > 0) this.startAutoplay(delay);
    }

    goTo(index) {
      this.current = (index + this.total) % this.total;
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
      this.dots.forEach((d, i) => d.classList.toggle('ecom-hero-slider__dot--active', i === this.current));
    }

    next() { this.goTo(this.current + 1); }
    prev() { this.goTo(this.current - 1); }

    startAutoplay(delay) {
      const tick = () => { this.autoplayTimer = setTimeout(() => { this.next(); tick(); }, delay); };
      tick();
      this.addEventListener('mouseenter', () => clearTimeout(this.autoplayTimer));
      this.addEventListener('mouseleave', () => tick());
    }
  }

  if (!customElements.get('ecom-hero-slider')) {
    customElements.define('ecom-hero-slider', EcomHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["micotix-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.ecom-reviews');
  sections.forEach(function(section) {
    var alignQuoteDesktop = section.style.getPropertyValue('--reviews-quote-align-desktop').trim();
    var alignQuoteMobile  = section.style.getPropertyValue('--reviews-quote-align-mobile').trim();
    var flexMap = { left: 'flex-start', center: 'center', right: 'flex-end' };
    section.style.setProperty('--reviews-quote-flex-align-desktop', flexMap[alignQuoteDesktop] || 'flex-start');
    section.style.setProperty('--reviews-quote-flex-align-mobile',  flexMap[alignQuoteMobile]  || 'center');
  });

  document.querySelectorAll('.ecom-reviews__nav').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var trackId = this.dataset.target;
      var track = document.getElementById(trackId);
      if (!track) return;
      var card = track.querySelector('.ecom-reviews__card');
      var cardW = card ? card.offsetWidth + parseInt(getComputedStyle(track).gap) : 240;
      var dir = this.classList.contains('ecom-reviews__nav--next') ? 1 : -1;
      track.scrollBy({ left: dir * cardW, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["micotix-tech-showcase"] && !Shopify.designMode) return;
  try {
    

(function () {

  function MtsTabs(sectionEl) {
    var tabs    = sectionEl.querySelectorAll('[data-mts-tab]');
    var panels  = sectionEl.querySelectorAll('.mts__panel');
    var footers = sectionEl.querySelectorAll('[data-mts-footer]');
    var nav     = sectionEl.querySelector('.mts__nav');

    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('mts__nav-btn--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('mts__panel--active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      footers.forEach(function (cell, i) {
        cell.classList.toggle('mts__footer-cell--active', i === index);
      });

      /* Scroll active tab into view on mobile */
      if (nav) {
        var activeTab = tabs[index];
        if (activeTab) {
          activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });

      /* Keyboard: arrow left/right between tabs */
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          activate(Math.min(i + 1, tabs.length - 1));
          tabs[Math.min(i + 1, tabs.length - 1)].focus();
        } else if (e.key === 'ArrowLeft') {
          activate(Math.max(i - 1, 0));
          tabs[Math.max(i - 1, 0)].focus();
        }
      });
    });

    footers.forEach(function (cell, i) {
      cell.addEventListener('click', function () { activate(i); });
    });
  }

  document.querySelectorAll('.mts').forEach(function (el) {
    MtsTabs(el);
  });

  /* Shopify theme editor re-init on section reload */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.mts');
    if (el) MtsTabs(el);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
